module.exports = __webpack_public_path__ + "img/theme13.721c81c4.png";